import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ordersApi, type Order, type OrderItem, type OrderIntelligence, type OrderTimelineEntry } from '../../api/orders';

export function OrderDetailPage() {
  const { id = '' } = useParams();
  const [order, setOrder] = useState<Order | null>(null);
  const [items, setItems] = useState<OrderItem[]>([]);
  const [timeline, setTimeline] = useState<OrderTimelineEntry[]>([]);
  const [intel, setIntel] = useState<OrderIntelligence | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    void ordersApi.get(id).then((d) => { setOrder(d.order); setItems(d.items); }).catch((e) => setError(String(e)));
    void ordersApi.timeline(id).then(setTimeline).catch(() => {});
    void ordersApi.intelligence(id).then(setIntel).catch(() => {});
  }, [id]);

  if (!order) return <div className="p-6">{error || 'Loading…'}</div>;

  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="text-2xl font-semibold">{order.order_number}</h1>
      <p className="text-sm text-slate-600">{order.source} · {order.status}</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        <div className="rounded border p-4"><p className="text-sm text-slate-500">Total</p><p className="text-xl font-semibold">{order.currency} {order.total_amount.toFixed(2)}</p></div>
        <div className="rounded border p-4"><p className="text-sm text-slate-500">Health</p><p className="text-xl font-semibold">{order.health_score}</p></div>
        <div className="rounded border p-4"><p className="text-sm text-slate-500">Allocation</p><p className="text-xl font-semibold">{order.allocation_status}</p></div>
      </div>
      <h2 className="mt-8 font-medium">Items</h2>
      <ul className="mt-2 space-y-2 text-sm">
        {items.map((i) => <li key={i.id} className="rounded border p-3">{i.title} × {i.quantity} — {i.total_price.toFixed(2)}</li>)}
      </ul>
      {intel && (
        <>
          <h2 className="mt-8 font-medium">AI Intelligence</h2>
          <p className="text-sm text-slate-600">SLA: {intel.sla_prediction} · Delay risk: {(intel.delay_risk * 100).toFixed(0)}%</p>
          <ul className="mt-2 space-y-1 text-sm">
            {intel.recommendations.map((r, idx) => <li key={idx}>{r.type}: {r.suggestion}</li>)}
          </ul>
        </>
      )}
      <h2 className="mt-8 font-medium">Timeline</h2>
      <ol className="mt-2 space-y-2 text-sm">
        {timeline.map((e) => <li key={e.id} className="border-l-2 pl-3">{e.status} — {e.message} <span className="text-slate-400">({e.recorded_at})</span></li>)}
      </ol>
    </div>
  );
}
